var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUploadDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2322 0H5C2.23858 0 0 2.23858 0 5V35C0 37.7614 2.23858 40 5 40H25C27.7614 40 30 37.7614 30 35V11.7678C30 11.1047 29.7366 10.4688 29.2678 10L20 0.732233C19.5312 0.263392 18.8953 0 18.2322 0ZM18.75 8.75V3.75L26.25 11.25H21.25C19.8693 11.25 18.75 10.1307 18.75 8.75ZM10.8839 24.6339C10.3957 25.122 9.60427 25.122 9.11612 24.6339C8.62796 24.1457 8.62796 23.3543 9.11612 22.8661L14.1161 17.8661C14.6043 17.378 15.3957 17.378 15.8839 17.8661L20.8839 22.8661C21.372 23.3543 21.372 24.1457 20.8839 24.6339C20.3957 25.122 19.6043 25.122 19.1161 24.6339L16.25 21.7678V31.25C16.25 31.9404 15.6904 32.5 15 32.5C14.3096 32.5 13.75 31.9404 13.75 31.25V21.7678L10.8839 24.6339Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUploadDocument);
export default __webpack_public_path__ + "static/media/ico-upload-document.04c8b55a6e4c5c85bdbcb46acd04a005.svg";
export { ForwardRef as ReactComponent };